"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorTrackingMock = exports.loggerTypeMock = void 0;
const loggerTypeMock = (debug) => debug
    ? console.log
    : () => {
        return;
    };
exports.loggerTypeMock = loggerTypeMock;
const errorTrackingMock = (debug) => debug
    ? console.log
    : () => {
        return;
    };
exports.errorTrackingMock = errorTrackingMock;
//# sourceMappingURL=TerminalUtils.js.map